import { Button, FileInput, Modal, Select, TextInput } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "../Common/Loader";
import { useAppDispatch, useAppSelector } from "../../Reducers/store";
import CommonApi from "../../Api/CommonApi";
import { SubCategoryManual } from "../../Models/SubCategoryManual";
import { SubCategoryCustom } from "../../Models/SubCategoryCustom";
import EquipmentApi from "../../Api/EquipmentApi";
import { Manufacturer } from "../../Models/Manufacturer";
import ManufacturerApi from "../../Api/ManufacturerApi";

export default function AddManualModal({
  show,
  setShow,
  selectedManual,
  getManuals,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  selectedManual: SubCategoryManual | null;
  getManuals: () => Promise<void> | undefined;
}) {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [fileUpload, setUploadFile] = useState<File | null>();
  const [subcategories, setsubcategories] = useState<SubCategoryCustom[]>([]);
  const [manufacturerWGData, setManufacturerWGData] = useState<
    Manufacturer[] | null
  >();

  const [formData, setFormData] = useState<SubCategoryManual>({
    id: 0,
    manufacturerId: null,
    subCategoryId: null,
    manualUrl: null,
    manualName: null,
    dateCreated: null,

    manufacturer: null,
    subCategory: null,
  });

  const getSubcategories = () => {
    setIsLoading(true);
    return CommonApi.getSubCategoriesCustom()
      .then((res) => {
        setsubcategories(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error("Error");
        setIsLoading(false);
      });
  };

  const getManufacturers = () => {
    setIsLoading(true);
    ManufacturerApi.getManufacturerListWG()
      .then((res) => {
        setManufacturerWGData(
          res.data.filter(
            (item) =>
              item.rimssOemvendorNumber?.startsWith("1") && item.active == true
          )
        );
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    getManufacturers();
    getSubcategories();
  }, []);

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.currentTarget.files) {
      setUploadFile(event.currentTarget.files[0]);
    } else {
      setUploadFile(null);
    }
  }

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    setIsLoading(true);
    let filepath = "";
    if (fileUpload) {
      const fd = new FormData();
      fd.append("file", fileUpload!);
      fd.append("directory", "manuals");
      setIsLoading(true);
      await EquipmentApi.addFile(fd)
        .then((res) => {
          if (res.data.success) {
            filepath = res.data.affectedEntityIdentifier;
          } else {
            toast.error(res.data.message);
            setIsLoading(false);
            setButtonDisabled(false);
          }
        })
        .catch((err) => {
          toast.error("Error: " + err);
          setIsLoading(false);
          setButtonDisabled(false);
        });
    }
    if (filepath.length > 0) {
      formData.manualUrl = filepath;
    }
    await EquipmentApi.addUpdateSubCategoryManual(formData)
      .then((res) => {
        if (res.data.success) {
          filepath = res.data.affectedEntityIdentifier;
          setIsLoading(false);
          setButtonDisabled(false);
          getManuals();
          onCloseModal();
        } else {
          toast.error(res.data.message);
          setIsLoading(false);
          setButtonDisabled(false);
        }
      })
      .catch((err) => {
        toast.error("Error: " + err);
        setIsLoading(false);
        setButtonDisabled(false);
      });
  };

  const handleSetInitialValues = () => {
    const values = selectedManual
      ? {
          ...selectedManual,
        }
      : {
          id: 0,
          manufacturerId: null,
          subCategoryId: null,
          manualUrl: null,
          manualName: null,
          dateCreated: null,

          manufacturer: null,
          subCategory: null,
        };
    setFormData(values as SubCategoryManual);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [selectedManual]);

  function onCloseModal() {
    setFormData({
      id: 0,
      manufacturerId: null,
      subCategoryId: null,
      manualUrl: null,
      manualName: null,
      dateCreated: null,

      manufacturer: null,
      subCategory: null,
    });
    setShow(false);
  }
  return (
    <Modal show={show} size="2xl" onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className="w-full">
          <div className="w-full">
            <div className="mx-1 flex items-end justify-center">
              <div className="flex flex-1 justify-center">
                <h1 className="text-gray-900 font-bold text-4xl">Add File</h1>
              </div>
            </div>
          </div>

          <div className="relative">
            {isLoading && <Loader />}
            <div className="container mx-auto p-2">
              <div className="md:flex no-wrap md:-mx-2 ">
                <div className="w-full">
                  <div className="bg-white">
                    <hr className="bg-gray-300 h-[5px]"></hr>
                    <form id="fileModal" onSubmit={onSubmit}>
                      <div className="text-gray-500">
                        <div className="grid grid-cols-[30%_70%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Manufacturer:
                            </div>
                          </div>
                          <div className="w-full">
                            <Select
                              id="manufacturerId"
                              name="manufacturerId"
                              onChange={handleChangeSelect}
                              value={formData.manufacturerId ?? ""}
                              sizing="md"
                              required
                            >
                              <option value={""}>(Select)</option>
                              {manufacturerWGData &&
                                manufacturerWGData.map((manufacturer) => (
                                  <option
                                    key={manufacturer.id}
                                    value={manufacturer.id}
                                  >
                                    {manufacturer.name}
                                  </option>
                                ))}
                            </Select>
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[30%_70%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Sub Category:
                            </div>
                          </div>
                          <div className="w-full">
                            <Select
                              id="subCategoryId"
                              name="subCategoryId"
                              onChange={handleChangeSelect}
                              value={formData.subCategoryId ?? ""}
                              sizing="md"
                              required
                            >
                              <option value={""}>(Select)</option>
                              {subcategories.map((sub) => (
                                <option key={sub.name} value={sub.number!}>
                                  {sub.name}
                                </option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[30%_70%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              Manual Name:
                            </div>
                          </div>
                          <div className="w-full">
                            <TextInput
                              id="manualName"
                              name="manualName"
                              type="text"
                              placeholder="Manual Name..."
                              onChange={handleChangeInput}
                              value={formData.manualName ?? ""}
                              sizing="md"
                              required
                            />
                          </div>
                        </div>
                        <hr className="bg-gray-300 h-[2px]"></hr>
                        <div className="grid grid-cols-[30%_70%] text-xl">
                          <div className="flex">
                            <div className="font-bold content-center">
                              File:
                            </div>
                          </div>
                          <div className="w-full">
                            <FileInput
                              id="file-upload"
                              onChange={handleFileChange}
                              disabled={buttonDisabled}
                              required={selectedManual === null ? true : false}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-end pt-2">
                        <Button
                          disabled={buttonDisabled}
                          type="submit"
                          className="buttonMain"
                          form="fileModal"
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
